import React from 'react';
import { motion } from 'framer-motion';
export type AnalyticsTab = 'acceptance' | 'authentication' | 'disputes' | 'payment-methods' | 'refunds';
interface AnalyticsTabsProps {
  activeTab: AnalyticsTab;
  onChange: (tab: AnalyticsTab) => void;
}
export function AnalyticsTabs({
  activeTab,
  onChange
}: AnalyticsTabsProps) {
  const tabs: {
    id: AnalyticsTab;
    label: string;
  }[] = [{
    id: 'acceptance',
    label: 'Acceptance'
  }, {
    id: 'authentication',
    label: 'Authentication'
  }, {
    id: 'payment-methods',
    label: 'Payment methods'
  }, {
    id: 'refunds',
    label: 'Refunds'
  }, {
    id: 'disputes',
    label: 'Disputes'
  }];
  return <div className="border-b border-gray-200" data-id="element-997">
      <div className="flex gap-6 overflow-x-auto" role="tablist" aria-label="Payment analytics" data-id="element-998">
        {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return <button key={tab.id} role="tab" aria-selected={isActive} aria-controls={`analytics-panel-${tab.id}`} id={`analytics-tab-${tab.id}`} onClick={() => onChange(tab.id)} className="relative pb-3 text-sm font-medium transition-colors whitespace-nowrap" data-id="element-999">
              <span className={isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'} data-id="element-1000">
                {tab.label}
              </span>
              {isActive && <motion.div layoutId="activeTab" className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600" transition={{
            type: 'spring',
            stiffness: 500,
            damping: 30
          }} data-id="element-1001" />}
            </button>;
      })}
      </div>
    </div>;
}